const updates = [
  {
    date: '2026.07.31',
    title: '平台新增超清视频专区上线',
    desc: '全新超清视频在线观看专区正式上线，汇集精选1080P高清画质内容，观影体验全面升级。',
    tag: '功能更新',
  },
  {
    date: '2026.07.28',
    title: 'CDN加速节点扩容完成',
    desc: '全国新增12个CDN加速节点，覆盖更多地区用户，播放流畅度提升40%以上。',
    tag: '技术升级',
  },
  {
    date: '2026.07.25',
    title: '移动端播放器优化发布',
    desc: '针对iOS和Android移动端浏览器进行了专项播放器优化，手势控制更加灵敏便捷。',
    tag: '产品优化',
  },
  {
    date: '2026.07.22',
    title: '每日更新内容量突破新高',
    desc: '本周91高清视频在线资源日更新量突破500部，内容覆盖更加全面多元。',
    tag: '内容动态',
  },
  {
    date: '2026.07.18',
    title: '自适应码率技术全面升级',
    desc: '智能码率切换算法更新，在网络波动环境下切换更平滑，大幅减少卡顿现象。',
    tag: '技术升级',
  },
  {
    date: '2026.07.15',
    title: '热门分类导航重新整理',
    desc: '优化了91国产高清视频与高清影视在线的分类结构，查找心仪内容更加高效直观。',
    tag: '体验优化',
  },
  {
    date: '2026.07.10',
    title: '服务器安全防护体系升级',
    desc: '完成新一轮安全加固，全面部署DDoS防护与企业级防火墙，保障平台稳定运行。',
    tag: '安全保障',
  },
  {
    date: '2026.07.05',
    title: '视频预加载功能上线测试',
    desc: '智能预加载技术进入测试阶段，系统自动预判用户喜好提前缓存内容，即点即播。',
    tag: '新功能',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            关注91麻豆免费视频网站的最新更新与平台动态
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>
          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="flex gap-5">
                <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-1">
                  <div className={`w-[10px] h-[10px] rounded-full border-2 flex-shrink-0 ${
                    idx === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-100 border-primary-400'
                  }`}></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-primary-200/50 transition-colors cursor-pointer">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}